import { call, put, takeEvery } from "redux-saga/effects";
import {
  ADD_PRE_ASSESSMENT_DATA,
  FETCH_PRE_ASSESSMENT_DATA,
  FETCH_PRE_ASSESSMENT_VIDEO,
  ATTEMPT_FAIL_PRE_ASSESSMENT,
  FETCH_PRE_ASSESSMENT_DATA_PUBLIC,
  SEND_PRE_ASSESSMENT_CONSENT_EMAIL,
} from "./actionTypes";
import {
  addPreAssessmentDataFailure,
  addPreAssessmentDataSuccess,
  fetchPreAssessmentDataSuccess,
  fetchPreAssessmentDataFailure,
  fetchPreAssessmentVideoSuccess,
  fetchPreAssessmentVideoFailure,
  attemptFailPreAssessmentSuccess,
  attemptFailPreAssessmentFailure,
  fetchPreAssessmentDataPublicSuccess,
  fetchPreAssessmentDataPublicFailure,
  sendPreAssessmentConsentEmailSuccess,
  sendPreAssessmentConsentEmailFailure,
} from "./action";
import {
  saveJobPreAssessmentData,
  getJobPreAssessmentData,
  getJobPreAssessmentVideo,
  attemptFailPreAssessment,
  getJobPreAssessmentDataPublic,
  sendPreAssessmentConsentEmail,
} from "../../helpers/backend_helper";
import { toast } from "react-toastify";

function* workAddPreAssessmentData(action) {
  try {
    const response = yield call(saveJobPreAssessmentData, action.payload);
    yield put(addPreAssessmentDataSuccess(response.data));
    toast.success("Pre-assessment data saved successfully");
  } catch (error) {
    yield put(addPreAssessmentDataFailure(error));
    toast.error("Failed to save pre-assessment data");
  }
}

function* workFetchPreAssessmentData(action) {
  try {
    const response = yield call(getJobPreAssessmentData, action.payload);
    yield put(fetchPreAssessmentDataSuccess(response.data));
  } catch (error) {
    yield put(fetchPreAssessmentDataFailure(error));
  }
}

function* workFetchPreAssessmentVideo(action) {
  try {
    const response = yield call(getJobPreAssessmentVideo, action.payload);
    yield put(fetchPreAssessmentVideoSuccess(response));
  } catch (error) {
    yield put(fetchPreAssessmentVideoFailure(error));
  }
}

function* workAttemptFailPreAssessment(action) {
  try {
    const response = yield call(attemptFailPreAssessment, action.payload);
    yield put(attemptFailPreAssessmentSuccess(response.data));
  } catch (error) {
    yield put(attemptFailPreAssessmentFailure(error));
    toast.error("Failed to save pre-assessment data");
  }
}

function* workFetchPreAssessmentDataPublic(action) {
  try {
    const response = yield call(getJobPreAssessmentDataPublic, action.payload);
    yield put(fetchPreAssessmentDataPublicSuccess(response.data));
  } catch (error) {
    yield put(fetchPreAssessmentDataPublicFailure(error));
  }
}

function* workSendPreAssessmentConsentEmail(action) {
  try {
    const response = yield call(sendPreAssessmentConsentEmail, action.payload);
    yield put(sendPreAssessmentConsentEmailSuccess(response.data));
  } catch (error) {
    yield put(sendPreAssessmentConsentEmailFailure(error));
    toast.error("Failed to send consent email");
  }
}

export default function* watchFetchPreAssessmentSaga() {
  yield takeEvery(ADD_PRE_ASSESSMENT_DATA, workAddPreAssessmentData);
  yield takeEvery(FETCH_PRE_ASSESSMENT_DATA, workFetchPreAssessmentData);
  yield takeEvery(FETCH_PRE_ASSESSMENT_VIDEO, workFetchPreAssessmentVideo);
  yield takeEvery(ATTEMPT_FAIL_PRE_ASSESSMENT, workAttemptFailPreAssessment);
  yield takeEvery(
    FETCH_PRE_ASSESSMENT_DATA_PUBLIC,
    workFetchPreAssessmentDataPublic
  );
  yield takeEvery(
    SEND_PRE_ASSESSMENT_CONSENT_EMAIL,
    workSendPreAssessmentConsentEmail
  );
}
